/**
 * Handles the setting of a sharpspring script.
 * @function
 * @param {string} siteHandle - Site handle (e.g. be-NL)
 * @param {string} sharpspringEndpointId - Endpoint for the Sharpspring script.
 */
export function handleSharpspringSubmit(siteHandle, sharpspringEndpointId) {
    const isNotBeLux =
        siteHandle !== 'mgMotorsBelgiumNl' &&
        siteHandle !== 'mgMotorsBelgiumFr' &&
        siteHandle !== 'mgMotorsLuxembourgFr';
    if (isNotBeLux) return;

    window.__ss_noform.push(['submit', null, sharpspringEndpointId]);
}
